import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { NavigationService } from '../navigation/navigation.service';
import { LocationContextService } from './location-context.service';

@Injectable()
export class LocationContextGuard implements CanActivate {
    constructor(
        private readonly locationContextService: LocationContextService,
        private readonly navigationService: NavigationService
    ) {}

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        // Check if overridden in route
        if (!route.data.onlyShowIfLocationContextIsValid) {
            return of(true);
        }

        // Check if location context is valid
        const isLocationContextValid = this.locationContextService.isLocationContextValid();

        // Redirect if location context is not valid
        if (!isLocationContextValid) {
            this.navigationService.redirectToTerminalSelection();
        }

        return of(isLocationContextValid);
    }
}
